import { useLocation, useNavigate } from "react-router-dom";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat";
import CommonBankLogo from "../../_utils/CommonBankLogo";
import ListContainer from "../../_utils/CommonListView/ListContainer";
import ListDualText from "../../_utils/CommonListView/ListSubComponent/ListDualText";
import ListTextWithIcon from "../../_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import "./index.css";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { useSelector } from "react-redux";
import ICONS from "../../../assets/Icons";
import SVGComponent from "../../_utils/SVGComponent";

const InternalTxnListViewCard = ({
  data,
  isSidebarOpen,
  isDistributionPopoverOpen,
  isPopoverOpen,
  currentStatus,
  txnHistorytype,
  onClose,
  paginationDivHeight,
  isLabelClicked,
  setLabelAccounts,
  setLabeldata,
  LabelAccounts,
  Labeldata,
  setlableInput,
  filterRef,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const listdata = data || [];
  const services = useSelector((state) => state.refreshToken.services);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  const getDistriStatusColor = (status) => {
    switch (status) {
      case "awaiting_verification":
      case "awaiting_funds":
      case "distribution_initiated":
      case "created":
      case "distribution_pending":
      case "approved":
        return "var(--queued)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "distribution_complete":
        return "var(--settled)";
      default:
        return "var(--text-primary)";
    }
  };

  return (
    <div className="standard-list-view-alignment gap-y-gap-sm gap-x-gap-lg">
      {listdata?.map((item) => {
        const approvalStatusText =
          currentStatus === "require approval"
            ? "Require approval"
            : item?.lifecycle_status || "N/A";

        const distributionStatusText =
          item?.distribution_lifecycle_status === "created"
            ? "Distribution created"
            : item?.distribution_lifecycle_status === "awaiting_funds"
              ? "Awaiting funds"
              : item?.distribution_lifecycle_status === "distribution_initiated"
                ? "Distribution initiated"
                : item?.distribution_lifecycle_status === "abandoned"
                  ? "Distribution abandoned"
                  : item?.distribution_lifecycle_status === "rejected"
                    ? "Distribution rejected"
                    : item?.distribution_lifecycle_status === "failed"
                      ? "Distribution failed"
                      : item?.distribution_lifecycle_status ===
                          "distribution_complete"
                        ? "Distribution complete"
                        : item?.distribution_lifecycle_status === "approved"
                          ? "Distribution approved"
                          : item?.distribution_lifecycle_status || "N/A";

        return (
          <ListContainer
            filterRef={filterRef}
            hoverHeight={GlobalConfiguration?.internalTxnListHoverHeight}
            key={item?.id}
            isSelected={
              isLabelClicked &&
              Array.isArray(LabelAccounts) &&
              LabelAccounts.includes(item?.txn_id)
            }
            isDisabled={
              isSidebarOpen || isPopoverOpen || isDistributionPopoverOpen
            }
            context={item}
            onClickHandler={(e) => {
              const options =
                item?.lifecycle_status === "pending" &&
                services?.includes("AInternalTxn")
                  ? {
                      state:
                        currentStatus === "require approval"
                          ? "require approval"
                          : item?.lifecycle_status,
                    }
                  : {};
              if (isLabelClicked) {
                e.stopPropagation();
                if (
                  Array.isArray(LabelAccounts) &&
                  LabelAccounts.includes(item?.txn_id)
                ) {
                  setLabelAccounts(
                    LabelAccounts.filter((id) => id !== item?.txn_id),
                  );
                } else {
                  setLabelAccounts([...LabelAccounts, item?.txn_id]);
                  setLabeldata([...Labeldata, item]);
                }
                setlableInput(false);
                return;
              }
              if (txnHistorytype === "internalTxnHistory") {
                onClose();
                navigate(
                  `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${item?.txn_id}`,
                  {
                    state: {
                      isViewAll:
                        location.pathname ===
                        "/internal_transaction_dashboard/internal_transaction_view_all"
                          ? true
                          : false,
                      options: options,
                    },
                  },
                );
              } else {
                let selection = window.getSelection();
                if (selection.toString().length === 0) {
                  if (!isSidebarOpen) {
                    navigate(
                      `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${item?.txn_id}`,
                      {
                        state: {
                          isViewAll:
                            location.pathname ===
                            "/internal_transaction_dashboard/internal_transaction_view_all"
                              ? true
                              : false,
                          options: options,
                        },
                      },
                    );
                  }
                } else {
                  navigate(
                    `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${item?.txn_id}`,
                    {
                      state: {
                        isViewAll:
                          location.pathname ===
                          "/internal_transaction_dashboard/internal_transaction_view_all"
                            ? true
                            : false,
                        options: options,
                      },
                    },
                  );
                }
              }
            }}
          >
            <list-body>
              <div className="w-full flex justify-between p-padding-sm gap-x-gap-sm">
                <div className="flex flex-col gap-y-gap-sm w-full">
                  {/* -------------- */}
                  <div className="w-full flex gap-x-gap-sm items-center">
                    <div className="flex flex-1 gap-y-gap-xs">
                      <span className="text-settled text-font-xs font-sans font-semibold ">
                        INR {<FormatAmount price={Number(item?.amount)} />}
                      </span>
                    </div>
                    <div className="border-l h-full border-primary-bg"></div>
                    <div className="flex gap-x-gap-xs justify-end items-center flex-1">
                      <span className="text-text-primary text-font-xs font-normal">
                        {item?.created_on
                          ? formatDateViewAll(item?.created_on, false, false)
                          : "Not given"}
                      </span>
                      {isLabelClicked && (
                        <div className="ml-margin-button-s">
                          {Array.isArray(LabelAccounts) &&
                          LabelAccounts.includes(item?.txn_id) ? (
                            <img
                              src={
                                "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                              }
                              className="w-icon-sm h-icon-sm"
                              alt=""
                            />
                          ) : (
                            <img
                              src={
                                "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                              }
                              className="w-icon-sm h-icon-sm"
                              alt=""
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="w-full flex gap-x-gap-sm items-center justify-between">
                    <div className="flex gap-gap-sm items-center">
                      <CommonBankLogo
                        variant="small"
                        ifsc={item?.owner_account_ifsc_code}
                        type="pill"
                      />
                      <span className="text-font-xs text-text-primary font-sans font-normal whitespace-nowrap">
                        {standardAccountNumberFormat(
                          item?.owner_account_bank_acc_no,
                          false,
                          true,
                        )}
                      </span>
                    </div>
                    <div className="mx-margin-xs">
                      <SVGComponent
                        url={ICONS?.ARROW_RIGHT_GREY}
                        color={"var(--text-secondary)"}
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                    <div className="flex gap-gap-sm items-center">
                      <span className="text-font-xs text-text-primary font-sans font-normal whitespace-nowrap">
                        {standardAccountNumberFormat(
                          item?.internal_account_bank_acc_no,
                          false,
                          true,
                        )}
                      </span>

                      <CommonBankLogo
                        variant="small"
                        ifsc={item?.internal_account_ifsc_code}
                        type="pill"
                      />
                    </div>
                    <>
                      {" "}
                      {item?.confidential_transaction === "Y" ? (
                        <img
                          className="w-icon-sm h-icon-sm"
                          src={ICONS?.CONFIDENTIAL_TRANSACTION}
                          alt="Confidential Internal Transaction"
                        />
                      ) : null}
                    </>
                  </div>
                </div>
              </div>
            </list-body>
            <list-hover>
              <ListDualText
                text1={approvalStatusText}
                subtext1="Approval status"
                text2={distributionStatusText}
                subtext2="Distribution status"
                text1FontWeight="var(--font-semibold)"
                text2FontWeight="var(--font-semibold)"
                text1Color={getStatusColor(item.lifecycle_status)}
                text2Color={
                  item.distribution_lifecycle_status === "N/A"
                    ? "var(--text-primary)"
                    : getDistriStatusColor(item.distribution_lifecycle_status)
                }
                textCase="none"
              />
              <ListTextWithIcon
                type={"text"}
                text={item?.labels?.join(", ") || "No labels assigned"}
                iconComponentArray={[
                  {
                    icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                  },
                ]}
              />
            </list-hover>
          </ListContainer>
        );
      })}
    </div>
  );
};

export default InternalTxnListViewCard;
